import { Capacitor } from "@capacitor/core";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { captureException } from "~/config/sentry";

const isNative = Capacitor.isNativePlatform();

export const ensureDirectoryExists = async (path: string): Promise<void> => {
  if (!isNative) return;

  try {
    const pathParts = path.split("/");
    pathParts.pop();
    const directoryPath = pathParts.join("/");

    if (!directoryPath) return;

    await Filesystem.mkdir({
      directory: Directory.Data,
      path: directoryPath,
      recursive: true,
    });
  } catch (error) {
    captureException(error, {
      contexts: {
        runtime: {
          isNative,
          path,
        },
      },
      tags: {
        component: "offline-storage",
        function: "ensureDirectoryExists",
      },
    });
  }
};
